// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d7baf2a","239":"9893ba47","455":"f449aaf8"}[chunkId] + ".chunk.js";
};